import type { Locale } from "@/lib/i18n";
import { pl, type CCompanyDigitalizationTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cCompanyDigitalizationTranslations: Record<Locale, CCompanyDigitalizationTranslations> = {
  pl,
  en,
  de,
};

export type { CCompanyDigitalizationTranslations };
